import React from "react";
import { CmpAskcoachfab } from "../../components/CmpAskcoachfab";
import { MobilityMiniCard } from "../../components/MobilityMiniCard";
import "./style.css";

export const MobilityPeekModal = () => {
  return (
    <div className="mobility-peek-modal" data-model-id="2265:2543">
      <div className="rectangle-wrapper">
        <div className="rectangle" />
      </div>

      <div className="cmp-mobilityminicard">
        <MobilityMiniCard
          className="mobility-mini-card-instance"
          clipPathGroup="/img/clip-path-group-2.png"
          elementMorningStretchClassName="mobility-mini-card-3"
          frameClassName="design-component-instance-node"
          img="/img/vector-5.svg"
          mobilityMiniCardClassName="mobility-mini-card-2"
          spanClassName="mobility-mini-card-4"
          spanClassNameOverride="mobility-mini-card-5"
          vector="/img/vector-4.svg"
        />
      </div>

      <div className="PD-fplaceholder-wrapper">
        <div className="PD-fplaceholder" />
      </div>

      <CmpAskcoachfab className="cmp-askcoachfab-instance" />
    </div>
  );
};
